import client from './client'

async function getCurrentTickets (service) {
  const response = await client.get('/services/' + service + '/current-tickets')

  return {
    currentTickets: response.data
  }
}

async function getNews () {
  const response = await client.get('/news')
  return { news: response.data }
}

export default {
  getCurrentTickets,
  getNews
}
